export default {
  namespaced: true,
  state: {
    fileList1: [
      // { file: "", content: "", url: "", loading: false },
      // { file: "", content: "", url: "", loading: false },
    ],
    fileList2: [
      // { file: "", content: "", url: "", loading: false },
      // { file: "", content: "", url: "", loading: false },
    ],
    fileList3:[
      // { file: "", content: "", url: "", loading: false },
      // { file: "", content: "", url: "", loading: false },
    ],
    ocrInt: false,
    upload_loading: false,
  },
  mutations: {
    setUploadLoading(state, target) {
      state.upload_loading = target;
    },
    setFileList1(state, target) {
      state.fileList1 = target;
      state.fileList1 = target;
    },
    setFileList1Result(state, target) {
      state.fileList1.forEach((item, index) => {
        item.result = target[index];
      });
    },
    removeFileList1(state, target) {
      state.fileList1.splice(0)
    },
    setFileList2(state, target) {
      state.fileList2 = target;
    },
    setFileList2Result(state, target) {
      state.fileList2.forEach((item, index) => {
        item.result = target[index];
      });
    },
    setFileList3(state, target) {
      state.fileList3 = target;
    },
    setFileList3Result(state, target) {
      state.fileList3.forEach((item, index) => {
        item.result = target[index];
      });
    },
    removeFileList3(state, target) {
      state.fileList3.splice(0)
    },
    removeFileList2(state,target){
      state.fileList2.splice(0)
    },

    setOcrInt(state, target) {
      state.ocrInt = target;
    },
  },
  actions: {},
  getters: {
    fileList1: (state) => state.fileList1,
    fileList2: (state) => state.fileList2,
  },
};
